<template>
  <div class="py-20">
    <div class="container mx-auto px-6">
      <div class="mx-auto max-w-7xl">
        <div v-reveal class="mb-16 text-center">
          <h2 class="mb-6 text-3xl font-bold text-ternary-dark dark:text-primary-light sm:text-4xl">
            {{ title }}
          </h2>
          <p class="mx-auto max-w-3xl text-lg text-gray-600 dark:text-gray-400">
            {{ description }}
          </p>
        </div>

        <div class="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          <div
            v-for="(service, index) in services"
            :key="service.title"
            v-reveal="(index % 3) * 90"
            class="group relative overflow-hidden rounded-2xl bg-card-gradient p-8 shadow-soft transition-all duration-500 hover:-translate-y-2 hover:shadow-soft-lg dark:bg-card-gradient-dark"
          >
            <div class="mb-6 flex size-16 items-center justify-center rounded-2xl bg-gradient-to-r from-accent to-gradient-end shadow-lg">
              <component :is="service.icon" class="size-8 text-white" />
            </div>
            <h3 class="mb-4 text-xl font-bold text-ternary-dark dark:text-ternary-light">
              {{ service.title }}
            </h3>
            <p class="text-gray-600 dark:text-gray-400">
              {{ service.description }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Service {
  icon: any
  title: string
  description: string
}

interface Props {
  title: string
  description: string
  services: Service[]
}

defineProps<Props>()
</script>
